import { render } from "./ShowCaisse.vue?vue&type=template&id=889a5838"
import script from "./ShowCaisse.vue?vue&type=script&lang=js"
export * from "./ShowCaisse.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__